import http from "./http";
import { wOrgIdMiddleware } from "../utils/commonUtils";
import { CREATED, OK } from "../utils/constant";
const IncidentService={
    getLookUpList:async(key)=>{
    try {
      const response = await http.GET(`lookup-list/${key}`);
      if (response.code === 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching Icd-10:", error);
      // throw error;
    }
    },
    getIncidentList:wOrgIdMiddleware( async (url,query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.GET(`${url}incident?${queryString}`);
      if (response.code === 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching incident:", error);
      // throw error;
    }
  },),
  //Save Incident
  saveIncident:wOrgIdMiddleware( async (url,data) => {
    try {
      const response = await http.POST(`${url}incident`, data);
      if (
        (response.code === OK || response.code === CREATED) &&
        response.data
      ) {
        return response;
      } else {
        return response;
      }
    } catch (error) {
      console.error("Error fetching incident:", error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },),

  //Delete Incident
  deleteIncident: wOrgIdMiddleware(async (url,id) => {
    try {
      const response = await http.DELETE(`${url}incident/${id}`);
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error("Error fetching incident:", error);
      throw error;
    }
  },),
  getIncidentById: wOrgIdMiddleware(async (url,id) => {
    try {
      const response = await http.GET(`${url}incident/${id}`);
      if (response.code === OK) {
        return response.data;
      }
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },),
  // Fetch related visits for an incident
  getVisitsByIncident: wOrgIdMiddleware(async (url, incidentId) => {
    try {
      const response = await http.GET(`${url}incident/by-incident/${incidentId}`);
      if (response.code === OK) {
        return response.data;
      }
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      // throw error;
    }
  },),
  updateIncidentById: wOrgIdMiddleware(async (url,id, data) => {
    try {
      const response = await http.PUT(`${url}incident/${id}`, data);
      if (
        response.code === OK  &&
        response.data
      ) {
        return response;
      } else {
        return response;
      }
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },),
  updateClaimNumber: wOrgIdMiddleware(async (url, id, claimNumber) => {
    try {
      const response = await http.PUT(`${url}incident/${id}/claim-number`, {
        claim_number: claimNumber
      });
      if (response.code === OK && response.data) {
        return response;
      } else {
        return response;
      }
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error("Error updating claim number:", error);
      throw error;
    }
  },),

}


export default IncidentService